import {useTranslation} from "next-i18next";
import {FilterAnyLabels} from "../../data/Filter/Filter.config";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";

interface MobileFilterMenuItemPropsInterface {
	label: string;
	selected: string[];
}

export default function MobileFilterMenuItem(
	props: MobileFilterMenuItemPropsInterface
) {
	const {t} = useTranslation();
	return (
		<button className="w-full flex gap-2 text-leo-button-gray items-center h-12">
			<div className="w-full flex justify-between">
				<div>{props.label}</div>
				<div
					className={`${
						props.selected.includes(FilterAnyLabels.BELIEBIG) ||
						props.selected.includes(t(FilterAnyLabels.BELIEBIG))
							? "text-leo-disabled-gray"
							: "text-leo-orange"
					}`}
				>
					{props.selected.map((v) => t(v)).join(" / ")}
				</div>
			</div>
			<div className="w-3.5 h-3.5">
				<IconArrowDown className="-rotate-90"/>
			</div>
		</button>
	);
}
